// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Nl-iW","picS":"_1RlUp","picM":"iD1u9","kalla":"_37DQT"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/utslapp/utslapp.scss
 ** module id = 451
 ** module chunks = 0
 **/